<div style="text-align: center; max-width: 630px">
  <div mat-dialog-content>
    <lemon-dialog-header> Lisää päiväsaldo manuaalisesti </lemon-dialog-header>

    <div style="padding: 0px 8%">
      <form>
        <div>
          <mat-form-field>
            <mat-label>Saldon päivä</mat-label>
            <input matInput [formField]="lomake.bankBalanceDate" [matDatepicker]="dayPicker" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="dayPicker"></mat-datepicker-toggle>
            <mat-datepicker #dayPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Saldon summa</mat-label>
            <input decimalNumberField matInput [formField]="lomake.bankBalanceSum" [numberOfDecimals]="2" />
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-secondary-button mat-dialog-close actionId="Peruuta (kirjanpito lisää tiliotteen saldo dialog)">Peruuta</app-secondary-button>
    <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
    <app-primary-button (click)="addBankBalance()" actionId="Lisätty päiväsaldo manuaalisesti" [actionContext]="[lomake().value()]">Lisää</app-primary-button>
  </div>
</div>
